import {mapActions, mapGetters} from "vuex"
import progress from "@/components/progress"

var preloader = {
  data() {
    return {
      inProgress: false
    }
  },
  computed: {
    ...mapGetters(['progress'])
  },
  watch: {
    progress(value) {
      this.inProgress = true
      Promise.all(value).then(() => {
        this.inProgress = false
      });
    }
  },
  methods: {
    ...mapActions(['background', 'queue']),
  },
  components: {
    'progress-bar': progress
  },
}

export default preloader
